module.exports = __webpack_public_path__ + "static/img/bing.6cd5e523.png";